import axios from "@/api/axios";

function getSettingsAuth(params) {
  return axios.get("services/v1.0/authorization_settings/", { params });
}

function getSettingsAuthByGroup(manageOrganizationGroupId) {
  const params = {
    manageOrganizationGroupId
  };
  return axios.get("services/v1.0/authorization_settings/", { params });
}

function getSettingsAuthByPremise(premiseId) {
  const params = {
    premiseId
  };
  return axios.get("services/v1.0/authorization_settings/", { params });
}

function login({ user, headers = {} }) {
  return axios.post("services/v1.0/personal-account/login/", user, { headers });
}

export default {
  getSettingsAuth,
  getSettingsAuthByGroup,
  getSettingsAuthByPremise,
  login
};
